import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { SeasonProvider } from "@/lib/SeasonContext";
import { Toaster } from "@/components/ui/sonner";
import AppLayout from "@/components/app/Layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Dashboard from "@/pages/Dashboard";
import StatsEntry from "@/pages/StatsEntry";
import Schedule from "@/pages/Schedule";
import Roster from "@/pages/Roster";
import Archive from "@/pages/Archive";
import Search from "@/pages/Search";
import PlayerProfile from "@/pages/PlayerProfile";
import BoxScore from "@/pages/BoxScore";
import Records from "@/pages/Records";
import Leaders from "@/pages/Leaders";
import AccessCards from "@/pages/AccessCards";
import PlayerCareer from "@/pages/PlayerCareer";
import Practice from "@/pages/Practice";
import "@/App.css";

function CoachOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-ink-950" />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <SeasonProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/search" element={<Search />} />
              <Route path="/leaders" element={<Leaders />} />
              <Route path="/records" element={<Records />} />
              <Route path="/player/:slug" element={<PlayerProfile />} />
              <Route path="/player/:slug/career" element={<PlayerCareer />} />
              <Route path="/game/:id" element={<BoxScore />} />
              <Route path="/dashboard" element={<CoachOnly><Dashboard /></CoachOnly>} />
              <Route path="/stats-entry" element={<CoachOnly><StatsEntry /></CoachOnly>} />
              <Route path="/roster" element={<CoachOnly><Roster /></CoachOnly>} />
              <Route path="/archive" element={<CoachOnly><Archive /></CoachOnly>} />
              <Route path="/access-cards" element={<CoachOnly><AccessCards /></CoachOnly>} />
              <Route path="/practice" element={<CoachOnly><Practice /></CoachOnly>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
      </SeasonProvider>
    </AuthProvider>
  );
}

export default App;
